import { useSelector } from 'react-redux';
import { Divider } from '@material-ui/core';
import AppBar from '@employee/AppBar';
import FilterSelectionBar, { EmployeeDashboardTabs } from './FilterSelectionBar';
import BidProfileSelection from './BidProfileSelection';
import TemplateSelection from './TemplateSelection';
import AssignedShiftlineSelection from './AssignedShiftlineSelection';
import './EmployeeDashboard.scss';
import ArchivedBidProfiles from './ArchivedBidProfiles';

function EmployeeDashboard() {
    /** @type {ShiftBidding.EmployeeStore} */
    // @ts-ignore
    const { employeeAppData } = useSelector((state) => state);
    const { selectedTab, search } = employeeAppData.employeeDashboardFilters;

    const generateTabContent = () => {
        switch (selectedTab) {
            case EmployeeDashboardTabs.Active:
                return <BidProfileSelection search={search?.trim()} />;
            case EmployeeDashboardTabs.Template:
                return <TemplateSelection search={search?.trim()} />;
            case EmployeeDashboardTabs.Assigned:
                return <AssignedShiftlineSelection search={search?.trim()} />;
            case EmployeeDashboardTabs.Archived:
                return <ArchivedBidProfiles search={search?.trim()} />;
            default:
                return <></>;
        }
    };

    return (
        <div className="employee-full-page">
            <AppBar />
            <FilterSelectionBar />
            <Divider />
            {
                generateTabContent()
            }
        </div>
    );
}

export default EmployeeDashboard;
